/*
 * Click & collect: pure basket decisions (docs/superpowers/specs/2026-09-30-click-and-collect-design.md).
 * No DOM, no fetch. Loaded in the browser as window.CartFulfilmentLogic, and
 * under Node for scripts/tests/cart-fulfilment-logic.test.mjs.
 *
 * Attribute contract (reaches the order as note_attributes):
 *   Fulfilment       Delivery | Collection
 *   Terms accepted   Delivery terms | Collection terms | ''
 *   Delivery Date    written by the Bird app (delivery only), e.g. "Oct 6, 2026"; never written by us
 *   Collection Date  written by us (collection only), same format as Bird's
 *   _BirdChimeSlotId Bird's own slot id. Bird writes it for a delivery (M=S). For a
 *                    collection we write M=P: Bird's checkout rate filter then shows only
 *                    its "Pick Up" rate. Ignored when Bird's rates are off (native pickup).
 */
(function (root) {
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function isSample(item) {
    return (item.tags || []).some(function (t) { return String(t).trim().toLowerCase() === 'sample'; });
  }
  function isSamplesOnly(items) {
    return items.length > 0 && items.every(isSample);
  }
  function normaliseMode(mode) {
    return mode === 'Collection' ? 'Collection' : 'Delivery';
  }
  // Bird's own slot id, e.g. "M=S;L=;D=2026-09-30;...": M=S is Shipping, D= the date.
  function birdSlotDate(slot) {
    var parts = {};
    String(slot || '').split(';').forEach(function (kv) { var i = kv.indexOf('='); if (i > 0) parts[kv.slice(0, i)] = kv.slice(i + 1); });
    return parts.M === 'S' && parts.D ? parts.D : null;
  }
  function pickupSlot(iso) {
    return 'M=P;L=;D=' + (iso || '') + ';T=;S=D';
  }
  function isOurPickupSlot(slot) {
    return /^M=P;/.test(String(slot || ''));
  }
  function dateFor(mode, attributes) {
    var a = attributes || {};
    if (normaliseMode(mode) === 'Collection') return a['Collection Date'] || null;
    return a['Delivery Date'] || birdSlotDate(a._BirdChimeSlotId) || null;
  }
  function weightText(totalGrams, anyWeightless) {
    if (anyWeightless || !totalGrams || totalGrams <= 0) return null;
    return 'about ' + Math.max(1, Math.round(totalGrams / 1000)).toLocaleString('en-GB') + ' kg';
  }
  // deliveryDateOptional: Bird's widget never rendered (blocked, slow, over its plan
  // limit). Delivery then needs only the tick, so nobody is locked out of paying; the
  // TMS flags a delivery with no date for a call.
  function cartFulfilmentState(input) {
    if (isSamplesOnly(input.items)) return { showChoice: false, canCheckout: true, missing: [] };
    var missing = [];
    var mode = normaliseMode(input.mode);
    var needsDate = mode === 'Collection' || !input.deliveryDateOptional;
    if (needsDate && !String(dateFor(mode, input.attributes) || '').trim()) missing.push('date');
    if (!input.ticked) missing.push('terms');
    return { showChoice: true, canCheckout: missing.length === 0, missing: missing };
  }
  function birdDate(iso) {
    var d = new Date(iso + 'T12:00:00Z');
    return MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + d.getUTCFullYear();
  }
  function dayName(iso) {
    return DAYS[new Date(iso + 'T12:00:00Z').getUTCDay()];
  }
  // What to save when the customer picks a mode, ticks, or picks a collection day.
  // The other mode's date is cleared so an order never carries both.
  function attributesForMode(mode, opts) {
    var m = normaliseMode(mode);
    var o = opts || {};
    var a = { Fulfilment: m, 'Terms accepted': o.ticked ? (m === 'Collection' ? 'Collection terms' : 'Delivery terms') : '' };
    // Bird's date keys (Delivery Date/Day/Method) are never touched: its widget keeps
    // showing its date, and the TMS reads the date that matches Fulfilment.
    if (m === 'Collection') {
      a['Collection Date'] = o.collectionIso ? birdDate(o.collectionIso) : '';
      a['Collection Day'] = o.collectionIso ? dayName(o.collectionIso) : '';
      a._BirdChimeSlotId = pickupSlot(o.collectionIso);
    } else {
      a['Collection Date'] = ''; a['Collection Day'] = '';
      // Drop the pickup slot Collect left behind; Bird's own shipping slot stays.
      if (isOurPickupSlot(o.currentSlot)) a._BirdChimeSlotId = '';
    }
    return a;
  }
  // The saved "Terms accepted" only counts for the mode it was given for.
  function termsAcceptedFor(mode, value) {
    return value === (normaliseMode(mode) === 'Collection' ? 'Collection terms' : 'Delivery terms');
  }
  // The tick's first link opens the chosen mode's terms page (Shopify page handle); the
  // second always opens the store's standard terms (Terms of service policy).
  var STANDARD_TERMS_HANDLE = 'terms-of-service';
  function termsHandle(mode) {
    return normaliseMode(mode) === 'Collection' ? 'collection-terms' : 'delivery-terms';
  }
  // The order notes box is redrawn from the saved cart note when the basket re-renders.
  // draft: what the customer last typed on this page (null if nothing). Returns the text
  // to put back in the redrawn box, or null to leave it as rendered.
  function noteToRestore(draft, current) {
    if (draft === null || draft === undefined) return null;
    return draft === current ? null : draft;
  }

  var api = {
    isSamplesOnly: isSamplesOnly, normaliseMode: normaliseMode, dateFor: dateFor, weightText: weightText,
    cartFulfilmentState: cartFulfilmentState, attributesForMode: attributesForMode, termsAcceptedFor: termsAcceptedFor, birdDate: birdDate, dayName: dayName, isOurPickupSlot: isOurPickupSlot,
    termsHandle: termsHandle, STANDARD_TERMS_HANDLE: STANDARD_TERMS_HANDLE, noteToRestore: noteToRestore,
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.CartFulfilmentLogic = api;
})(this);
